import { Box, Card } from "@mui/material"
import { styled } from "@mui/material/styles"
import { BoxProps } from "./FormCardButton.interfaces"

export const StyledBox = styled(Box)<BoxProps>(({ color }) => ({
  minHeight: "200px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "30px 15px",
  flexDirection: "column",
  textAlign: "center",
  boxShadow: "1px 3px 3px 0px rgba(0, 0, 0, 0.10)",
  "&:hover": {
    backgroundColor: color
  }
}))

export const StyledCard = styled(Card)({
  cursor: "pointer"
})

export const StyledIconBox = styled(Box)(({ color }: BoxProps) => ({
  color
}))
